<template>
  <div class="table">
    <el-table
      :data="allRules"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      empty-text=""
      v-loading="tableLoading || loading"
    >
      <div slot="empty">
        <NoDataToView
          v-if="!loading"
          link="/admin/attendance/overtime/settings/overtime-rule/create"
          :showButton="showCreateOvertimeRule"
          btnText="Overtime Rule"
        >
          <template slot="message">
            <p>
              {{ noDataMessage }} &nbsp;<button
                v-if="!showCreateOvertimeRule"
                @click="$emit('clear')"
                class="pointer blue underline"
              >
                clear
              </button>
            </p>
          </template>
        </NoDataToView>
      </div>
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="id" width="80"></el-table-column>
      <el-table-column
        sortable
        prop="group_name"
        label="RULES NAME"
      ></el-table-column>
      <el-table-column sortable prop="actions" label="ACTIONS">
        <template slot-scope="scope">
          <div class="actions">
            <button @click="viewOvertimeRule(scope.row.id)">
              <img src="/img/view.svg" alt="view" />
            </button>
            <button @click="handleEditOvertimeRule(scope.row.id)">
              <img src="/img/pencil-edit.svg" alt="edit" />
            </button>
            <button @click="deleteAOvertimeRule(scope.row.id)">
              <img src="/img/delete.svg" alt="delete" />
            </button>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="150">
        <template slot-scope="scope">
          <button
            class="line pointer black"
            @click="assignEmployee(scope.row.id)"
          >
            Assign Employee
          </button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        mini
        @size-change="handleSizeChangeRules"
        @current-change="handleCurrentChangeRules"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPageRules"
        layout="total, sizes, prev, pager, next, jumper"
        :total="rulesTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import NoDataToView from "@/components/general/NoDataToView.vue";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "admin/attendance/overtime"
);
export default {
  components: {
    NoDataToView,
  },
  props: ["allRules", "searchQuery", "rulesTotal"],

  data() {
    return {
      loading: false,
      pageSizes: this.$store.state.admin.pageSizes,
    };
  },
  computed: {
    ...mapState(["tableLoading", "pageRules", "perPageRules"]),
    currentPage: {
      get() {
        return this.pageRules;
      },
      set(value) {
        return this.$store.commit(
          "admin/attendance/overtime/OVERTIME_MUTATIONS",
          {
            key: "pageRules",
            value,
          }
        );
      },
    },
    showCreateOvertimeRule() {
      return !this.allRules.length && !this.searchQuery;
    },
    noDataMessage() {
      let message = `You are yet to create any overtime rule`;
      if (this.showCreateOvertimeRule) {
        return message;
      }
      if (this.searchQuery !== "") {
        return `${message} ${this.searchQuery ? "for " : ""} ${
          this.searchQuery
        } `;
      }
      return `${message}`;
    },
  },
  methods: {
    ...mapActions([
      "deleteRule",
      "getAllRules",
      "handleSizeChangeRules",
      "handleCurrentChangeRules",
    ]),
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    handleEditOvertimeRule(id) {
      this.$router.push(
        `/admin/attendance/overtime/settings/overtime-rule/edit/${id}`
      );
    },
    deleteAOvertimeRule(id) {
      this.$promptModal(
        "Delete Overtime Rule",
        "Are you sure you want to delete the selected overtime rule?",
        "Yes, Delete",
        () => this.handleDeleteOvertimeRule(id)
      );
    },
    handleDeleteOvertimeRule(id) {
      this.loading = true;
      this.deleteRule(id)
        .then(() => {
          this.loading = false;
          this.getAllRules();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    viewOvertimeRule(id) {
      this.$router.push({
        name: "view-overtime-rule-settings",
        params: { id },
      });
    },
    assignEmployee(id) {
      this.$router.push({
        name: "assign-employee-overtime-rule",
        params: { id },
      });
    },
  },
};
</script>
